import type { PixelSprite } from '../types.js';
const variant0: PixelSprite = {
  layers: [
    {
      paint: 'boulder',
      d: 'M0,-2.5h0.5v2h-0.5zM2.5,-0.5h0.5v0.5h-0.5zM-2,0h0.5v0.5h-0.5zM1.5,0h1.5v0.5h-1.5zM0,0.5h2v0.5h-2z',
    },
    {
      paint: 'fountain',
      d: 'M-1,-3h2v0.5h-2zM-0.5,-2.5h0.5v0.5h-0.5zM-1.5,-2h1.5v0.5h-1.5zM0.5,-2h1v0.5h-1zM-3,-1.5h1.5v0.5h-1.5zM-0.5,-1.5h0.5v1h-0.5zM1.5,-1.5h1.5v0.5h-1.5zM-3,-1h1v0.5h-1zM2,-1h1v0.5h-1zM-3,-0.5h1.5v0.5h-1.5zM1.5,-0.5h1v0.5h-1zM-3,0h1v0.5h-1zM-1.5,0h3v0.5h-3zM-2.5,0.5h2.5v0.5h-2.5z',
    },
    {
      paint: 'fountainWater',
      d: 'M-1,-4.5h0.5v0.5h-0.5zM0.5,-4.5h0.5v1h-0.5zM-1.5,-4h1v0.5h-1zM-1.5,-3.5h0.5v0.5h-0.5zM1,-3.5h0.5v0.5h-0.5zM-2,-3h1v1h-1zM1,-3h1v1h-1zM-2,-2h0.5v0.5h-0.5zM1.5,-2h0.5v0.5h-0.5zM-1.5,-1.5h1v0.5h-1zM0.5,-1.5h1v0.5h-1zM-2,-1h1.5v0.5h-1.5zM0.5,-1h1.5v0.5h-1.5zM-1.5,-0.5h3v0.5h-3z',
    },
    { paint: 'waterLight', d: 'M-0.5,-5h1v1.5h-1zM-1,-3.5h2v0.5h-2z' },
  ],
  pixels: 96,
};
export const sprites: readonly PixelSprite[] = [variant0, variant0, variant0];
